import React from 'react'
import { Provider } from 'react-redux'
import { PropTypes } from 'prop-types'
import { getInitialAuthorization } from '../middleware/authHeaders'

const ReduxProvider = ({ children, reduxStore }) => {
  getInitialAuthorization(reduxStore)
  return <Provider store={reduxStore}>{children}</Provider>
}

ReduxProvider.propTypes = {
  children: PropTypes.node.isRequired,
  reduxStore: PropTypes.shape({}).isRequired,
}

export default ReduxProvider
